import { render, staticRenderFns } from "./redmine_filter.vue?vue&type=template&id=894edfd2&scoped=true&"
import script from "./redmine_filter.vue?vue&type=script&lang=js&"
export * from "./redmine_filter.vue?vue&type=script&lang=js&"
import style0 from "./redmine_filter.vue?vue&type=style&index=0&id=894edfd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894edfd2",
  null
  
)

export default component.exports